import React from 'react';
import GestureIcon from '@mui/icons-material/Gesture';

const styles = {
  container: {
    width: '100%',
    border: '1px dashed var(--mui-palette-divider)',
    borderRadius: '8px',
    padding: '24px',
    textAlign: 'center',
    backgroundColor: 'var(--mui-palette-action-hover)',
    minHeight: '120px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },
  label: {
    fontSize: '13px',
    color: 'var(--mui-palette-text-secondary)',
  },
  modeLabel: {
    fontSize: '11px',
    color: 'var(--mui-palette-text-disabled)',
    fontStyle: 'italic',
  },
};

const ImageAnnotation = ({ data }) => {
  const mode = data?.sourceMode || 'user_upload';

  return (
    <div style={styles.container}>
      <GestureIcon style={{ fontSize: 32, color: 'var(--mui-palette-text-secondary)' }} />
      <span style={styles.label}>Image Annotation</span>
      <span style={styles.modeLabel}>
        {mode === 'preset_url' ? 'Preset image (URL)' : mode === 'preset_upload' ? 'Preset image (uploaded)' : 'User uploads image'}
      </span>
    </div>
  );
};

export default ImageAnnotation;
